"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useCombobox(props) {
  var defaultInputValue = props.defaultInputValue,
      label = props.label,
      inputValue = props.inputValue,
      onChangeInputValue = props.onChangeInputValue;

  var _useState = (0, _react.useState)({
    internalInputValue: inputValue || defaultInputValue || ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
  /**
   * NOTE: This is for internal updates only.
   * This will NOT call the `onChangeInputValue` prop.
   */


  var setInternalInputValue = (0, _react.useCallback)(function (newInternalInputValue) {
    setState(
    /**
     * A functional state update means React can optimize this, but comes with some
     * gotchas. Specifically, the synthetic event used above may no longer exist when
     * this function is called.
     */
    function (s) {
      return _objectSpread({}, s, {
        internalInputValue: newInternalInputValue || ''
      });
    });
  }, [setState]);
  /**
   * If the input value prop changes, it should always override any locally maintained
   * current values. This allows the component to be controlled.
   */

  (0, _react.useEffect)(function () {
    if (typeof inputValue === 'string' && inputValue !== state.internalInputValue) {
      setInternalInputValue(inputValue);
    }
  }, [inputValue, state.internalInputValue, setInternalInputValue]);
  var getInputFieldProps = (0, _react.useCallback)(function () {
    return _objectSpread({}, props, {
      label: label,
      value: inputValue || state.internalInputValue,
      onChange: function onChange(event) {
        setInternalInputValue(event && event.target.value);

        if (onChangeInputValue) {
          onChangeInputValue(event);
        }
      }
    });
  }, [inputValue, label, props, onChangeInputValue, setInternalInputValue, state.internalInputValue]);
  return {
    getInputFieldProps: getInputFieldProps,
    internalInputValue: state.internalInputValue,
    setInternalInputValue: setInternalInputValue
  };
}

var _default = useCombobox;
exports.default = _default;